var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ag-grid-vue',{key:_vm.sanitizedOptions.props.BI.key,class:_vm.sanitizedOptions.class,style:(_vm.sanitizedOptions.style),attrs:{"gridOptions":_vm.gridOptions,"context":_vm.context,"modules":_vm.modules}})
}
var staticRenderFns = []

export { render, staticRenderFns }